import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import MembershipServiceListServices from '../services/MembershipServiceListServices';
import useAsync from '../hooks/useAsync';
import HelpTogal from './TogelButton/HelpTogal';
import Modal from 'react-modal';
import DeleteButton from './Button/DeleteButton';
import UpdateMembershipService from './Update Model/UpdateMembershipService';
import ViewMembershipService from './View Model/ViewMembershipService';
import * as XLSX from 'xlsx';

Modal.setAppElement('#root');

function MembershipServiceList() {
  const { data, error, isLoading, run } = useAsync(MembershipServiceListServices.getServiceMembership);

  const [activeIndex, setActiveIndex] = useState(null);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [selectedEdit, setSelectedEdit] = useState(null);
  const [searchQuery, setSearchQuery] = useState('');
  const [selectedMembership, setSelectedMembership] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleEditDetails = (membershipService) => {
    setSelectedEdit(membershipService);
    setIsEditModalOpen(true);
    toggleActionMenu(null);
  };

  const handleViewDetails = (membershipService) => {
    setSelectedMembership(membershipService);
    setIsModalOpen(true);
    toggleActionMenu(null);
  };

  const handleDelete = (membershipService) => {
    setSelectedEdit(membershipService);
    setIsDeleteModalOpen(true);
    toggleActionMenu(null);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setSelectedMembership(null);
  };

  const closeEditModal = () => {
    setIsEditModalOpen(false);
    setSelectedEdit(null);
  };

  const closeDeleteModal = () => {
    setIsDeleteModalOpen(false);
    setSelectedEdit(null);
  };

  const toggleActionMenu = (index) => {
    setActiveIndex(index === activeIndex ? null : index);
  };

  const formatDateTime = (isoString) => {
    if (!isoString) return '-';
    const date = new Date(isoString);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  };

  // SEARCH FIX
  const filteredData = data?.data?.filter((membershipService) =>
    membershipService?.membershipId?.name?.toLowerCase().includes(searchQuery.toLowerCase().trim()) ||
    membershipService?.serviceId?.title?.toLowerCase().includes(searchQuery.toLowerCase().trim())
  );

  if (isLoading) {
    return (
      <div className="right_col" role="main">
        <div className="text-center py-5">
          <div className="spinner-border text-primary"></div>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="right_col" role="main">
        <div className="alert alert-danger m-3">
          Error loading memberships
        </div>
      </div>
    );
  }

  return (
    <div className="right_col" role="main">
      <div className="d-md-flex align-items-center justify-content-between my-4 page-header-breadcrumb">
        <div className="my-auto">
          <h5 className="page-title fs-21 mb-1">
            Membership Service List
            <span className="badge bg-orange ms-2">
              {filteredData?.length || 0}
            </span>
          </h5>
        </div>

        <div className="d-flex my-xl-auto gap-2 right-content align-items-center">
          <Link className="round-add-btn" to="/add-membership-service">
            <img src="img/plus.svg" alt="Add Membership Service" />
          </Link>
        </div>
      </div>

      {/* Search */}
      <div className="container-box px-0 pt-2">
        <div className="Tablesearch_design">
            <div className="row">
              <div className='col-md-6'>
                <div className='d-flex align-items-center justify-content-between gap-2'>
                  <input
                    type="search"
                    name="search"
                    placeholder="Search"
                    value={searchQuery}
                    className='form-control'
                    onChange={(e) => setSearchQuery(e.target.value)}
                  />
                  <button className="search-btn" onClick={() => setSearchQuery(searchQuery)}>Search</button>
                </div>
              </div>
            </div>
          </div>

        {/* Table */}
        <div className="container-box-inner table-reponsive-tabe">
          <table className="table table-striped" style={{ width: "100%" }}>
            <thead>
              <tr>
                <th>#</th>
                <th>Membership</th>
                <th>Service</th>
                <th>Max Orders</th>
                <th>Max Discount</th>
                <th>Discount %</th>
                <th>Date</th>
                <th>Status</th>
                <th>Action</th>
              </tr>
            </thead>

            <tbody>
              {filteredData && filteredData.length > 0 ? (
                filteredData.map((membershipService, i) => (
                  <tr key={membershipService._id}>
                    <td>{i + 1}</td>
                    <td>{membershipService?.membershipId?.name || '-'}</td>
                    <td>{membershipService?.serviceId?.title || '-'}</td>
                    <td>{membershipService?.rules?.maxOrdersPerDay || '-'}</td>
                    <td>{membershipService?.rules?.maxDiscountPerOrder || '-'}</td>
                    <td>{membershipService?.rules?.discountPercent || '-'}</td>
                    <td>{formatDateTime(membershipService?.createdAt)}</td>
                    <td className="status-toggle">
                      <HelpTogal help={membershipService} page="MembershipService" onSuccess={() => run()} />
                    </td>
                    <td>
                      <div className="action_toggle_outer">
                        <button className="action_toggle" onClick={() => toggleActionMenu(i)}>
                          <i className="fa fa-ellipsis-v" />
                        </button>
                        {activeIndex === i && (
                          <div className="action_toggle_content product-edit show d-block">
                            <ul className="list-unstyled">
                              <li>
                                <button className="close_toggle" onClick={() => toggleActionMenu(null)}>
                                  <i className="fa fa-close" />
                                </button>
                              </li>
                              <li>
                                <button className="approve"   style={{ backgroundColor: '#263238' }} onClick={() => handleViewDetails(membershipService)}>View</button>
                              </li>
                              <li>
                                <button className="edit" onClick={() => handleEditDetails(membershipService)}>Edit</button>
                              </li>
                              <li>
                                <button className="reject" onClick={() => handleDelete(membershipService)}>Delete</button>
                              </li>
                            </ul>
                          </div>
                        )}
                      </div>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="9" className="text-center py-4">
                    No memberships found
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>

  <Modal
          isOpen={isEditModalOpen}
          onRequestClose={closeEditModal}
          className="modal-content"
          overlayClassName="modal-overlay"
        >
          <UpdateMembershipService membership={selectedEdit} closeModal={closeEditModal} onSuccess={run} />
        </Modal>

        <Modal
          isOpen={isDeleteModalOpen}
          onRequestClose={closeDeleteModal}
          className="modal-content"
          overlayClassName="modal-overlay"
        >
          <DeleteButton data={selectedEdit} page="MembershipService" closeModal={closeDeleteModal} onSuccess={run} />
        </Modal>
        
        <Modal
          isOpen={isModalOpen}
          onRequestClose={closeModal}
          contentLabel="View Membership"
          className="modal-content"
          overlayClassName="modal-overlay"
        >
          <ViewMembershipService service={selectedMembership} closeModal={closeModal} />
        </Modal>
      
    </div>
  );
}

export default MembershipServiceList;